export default __webpack_public_path__ + "a0bd633e4e895e069f6d2f4a4f4631b3.png";